import { View } from "ui/atoms/view";
import { Text } from "react-native";
import { PermissionCheck } from "../../permission/atoms/PermissionCheck";
import { PermissionsEnums } from "../../../services/api/types/authorisation/enums/PermissionsEnums";
import { Button, ButtonText } from "ui/gluestack/button";
import {
  FormEnums,
  NewFormButtonText,
} from "../../../services/api/types/forms/enums/FormEnums";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";
import { Accordion } from "ui/gluestack/accordion";
import Pagination from "ui/molecules/pagination/Pagination";
import { NoItemsComponent } from "ui/atoms/noItems";
import { FluidOutputHistoryItem } from "../organisms/FluidOutputHistoryItem";
import { useHandleFluidOutput } from "../hooks/useHandleFluidOutput";
import { useRef } from "react";
import { CreateFluidOutputModal } from "../modals/CreateFluidOutputModal";
import { formatDate } from "ui/utils/dateUtils";

export function FluidOutputTemplate() {
  const tag = FormEnums.FLUID_INTAKE_OUTPUT_REPORT;

  const { data, isHistoryLoading, handlePageChange, fluidOutputTotal, meta } =
    useHandleFluidOutput({
      onSuccess: () => {},
    });

  const ref = useRef<React.ComponentRef<typeof CreateFluidOutputModal>>(null);
  const handleShowModal = () => {
    ref.current?.show();
  };

  const todayDate = new Date();

  return (
    <View className="resident-container">
      <View className="flex-row justify-between items-center">
        <CreateFluidOutputModal ref={ref} />
        <Text className="text-lg text-primary-700 font-semibold">
          Fluid Output
        </Text>
        <PermissionCheck permission={PermissionsEnums.CREATE_FLUID_OUTPUT}>
          <Button
            action="primary"
            size="sm"
            className="mb-3 ml-auto"
            onPress={handleShowModal}
          >
            <ButtonText className="text-xs sm:text-base">
              {NewFormButtonText[tag]}
            </ButtonText>
          </Button>
        </PermissionCheck>
      </View>
      <View className="border border-gray-200 w-full mt-4 mb-11" />
      <View className="mb-11">
        <Text className="text-primary-400 text-base font-semibold mb-2">
          Total Fluid Output
        </Text>
        <Text className="text-typography-600">{formatDate(todayDate)}</Text>
      </View>
      <View className="flex-row items-center gap-1.5">
        {fluidOutputTotal > 0 ? (
          <Text className="text-typography-900 font-semibold text-4xl">
            {fluidOutputTotal}
          </Text>
        ) : (
          <Text className="text-typography-300 font-semibold text-4xl">
            {fluidOutputTotal}
          </Text>
        )}
        <Text className="text-typography-600">ml</Text>
      </View>
      <View className="border border-gray-200 w-full mt-11 mb-11" />
      <View className="mb-11">
        <Text className="text-primary-400 text-base font-semibold mb-2">
          Output Log
        </Text>
      </View>
      <View className="flex-column gap-3">
        {isHistoryLoading ? (
          <LoadingSpinner />
        ) : data?.length ? (
          <View>
            <Accordion type="single" variant="filled" className="mb-4 w-full">
              {data?.map((log) => (
                <FluidOutputHistoryItem key={log.id} log={log} />
              ))}
            </Accordion>
            <Pagination meta={meta} onPageChange={handlePageChange} />
          </View>
        ) : (
          <NoItemsComponent
            className="py-5"
            title="No items!"
            subtitle={`${tag && NewFormButtonText[tag] ? ` Click on the "${NewFormButtonText[tag]}" button above to log a new item` : ""}`}
          />
        )}
      </View>
    </View>
  );
}
